import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { of, ReplaySubject, Subject } from 'rxjs';
import { debounceTime, delay, distinctUntilChanged, exhaustMap, map, take, takeUntil, tap } from 'rxjs/operators';
import { IExternalEntity, IExternalEntityCriteria } from 'src/app/masters/peoples/external-entity/external-entity.interface';
import { IDestination } from 'src/app/masters/places/destination/destination.interface';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { DeactivateComponent } from 'src/app/shared/components/deactivate/deactivate.component';
import { ReactivateComponent } from 'src/app/shared/components/reactivate/reactivate.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IDestinationCriteria, IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from "underscore";
import { IConsortium, IConsortiumCriteria, IConsortiumDestination } from '../../consortium/consortium.interface';
import { unionBy } from 'lodash';

@Component({
    selector: 'app-liner-service-form',
    templateUrl: './liner-service-form.component.html',
    styleUrls: ['./liner-service-form.component.less'],
    standalone: false
})
export class LinerServiceFormComponent implements OnInit,AfterViewChecked {
  constructor(private logger:NGXLogger, private service:DataService,private router:Router,
              private formBuilder:FormBuilder,private changeDetectorRef:ChangeDetectorRef,
              private permissionService:PermissionService,private utilityService:UtilityService,
              private activatedRoute:ActivatedRoute,private dailog:MatDialog) { }

  filteredLines:ReplaySubject<IExternalEntity[]> = new ReplaySubject<IExternalEntity[]>(1);
  filteredDestinations:ReplaySubject<IDestination[]> = new ReplaySubject<IDestination[]>(1);
  filteredConsortium:ReplaySubject<IConsortium[]> = new ReplaySubject<IConsortium[]>(1);
  filteredConsortiumDest:ReplaySubject<IConsortiumDestination[]> = new ReplaySubject<IConsortiumDestination[]>(1);
  lineSearchCtrl=this.formBuilder.control('');
  destinationSearchCtrl=this.formBuilder.control('');
  consortiumSearchCtrl=this.formBuilder.control('');
  polSearchCtrl=this.formBuilder.control('');
  @Input() searching: boolean = false;
  destinations:any;
  consortiumDestinations:any;
  lines:any;
  consortiums:any;
  portOfLoadings:any;
  selectedConsortium:any;
  lineCriteria:IExternalEntityCriteria={};
  consortiumCriteria:IConsortiumCriteria={}
  linerServiceForm:FormGroup;
  modes:any;
  showStatus: string;
  serviceResData:any;
  onDestroy=new Subject<void>();
  editPermission:boolean=false;
  addPermission:boolean=false;
  reactivatePermission:boolean=false;
  deactivatePermission:boolean=false;
  showDeactivateToggle:boolean=false;
  showReactivateToggle:boolean=false;
  checked:boolean=false;
  yesNoList = this.utilityService.getYesNoList();
  isEditedData:boolean=false;
  destinationCriteria:IDestinationCriteria={};

  ngOnInit(): void {
    this.initializeForm();
    this.checkAllPermissions();
    this.getLineList();
    this.getPortOfLoadings();
    this.getModeList();
    this.filterLines();
    this.filterConsortium();
    this.filterConsortiumDestination();
    this.setLineValueChangeEvent();
    this.setConsortiumValueChangeEvent();
    this.filterDestinations();
    this.getDestinationList();
    this.setTerminalValueChangeEvent();
    this.setDestinationValueChangeEvent();
    this.activatedRoute.params.subscribe(
      (param:Params) => {
        if(+param['id'])
          this.id.setValue(+param['id']);
    });
    this.getLinerServiceById();
  }

  initializeForm(){
    this.linerServiceForm=this.formBuilder.group({
      id:[],
      status:[],
      activeFlag:[],
      parentId:[],
      viewLog:[],
      lineId:[null,[Validators.required]],
      consortiumId:[null,[Validators.required]],
      transitTime:[null,[Validators.required,Validators.pattern('^[1-9]+[0-9]*$')]],
      polId:[null,[Validators.required]],
      destinationId:[null,[Validators.required]],
      linerServiceDetails:this.formBuilder.array([])
    })
    this.serviceFormInitial(2);
  }

  private serviceFormInitial(count :number){
    for (let i = 0; i < count; i++) {
      this.linerServices.push(this.ServiceForm());
    }
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  setLineValueChangeEvent(value?:number){
    let selectedLines: any;
        this.filteredLines.pipe(take(1)).subscribe(lineList => {
          selectedLines = this.lines.find(line => line.id === value) ||
          lineList.find(line => line.id === value);
        });
        if (selectedLines && !this.lines.some(line => line.id === selectedLines.id)) {
          this.lines.push(selectedLines);
        }

    this.lineId.valueChanges.subscribe(lineValue => {
      this.polId.reset();
      this.destinationId.reset();
      this.consortiumCriteria.lineId=lineValue;
      this.consortiumCriteria['activeFlag.equals']=true;
      this.resetServices();
      this.getConsortiumList();
    });
  }

  private resetServices(){
    this.linerServices.clear();
    this.serviceFormInitial(2);
  }

  setTerminalValueChangeEvent(){
    this.polId.valueChanges.subscribe(polValue => {
      this.resetServices();
      this.linerServices.at(0).get('portId').setValue(polValue);
    })
  }

  setConsortiumValueChangeEvent(setValue?:boolean){
    this.consortiumId.valueChanges.subscribe(consortiumValue => {
      this.selectedConsortium=_.findWhere(this.consortiums,{id:consortiumValue});
      if(this.selectedConsortium){
        this.polId.reset();
        this.consortiumDestinations=this.selectedConsortium.destinationDetails;
        this.filteredConsortiumDest.next(this.consortiumDestinations);
        this.resetServices();
      }
    });
  }


  consortiumDestinationList(consortiumId:number){
   if(consortiumId){
        this.selectedConsortium=_.findWhere(this.consortiums,{id:consortiumId});
        if(this.selectedConsortium){
          this.polId.reset();
          this.consortiumDestinations = this.selectedConsortium.destinationDetails || [];
          this.destinations = unionBy(this.destinations, this.consortiumDestinations, 'id');
            this.filteredDestinations.next([...this.destinations]);
            this.resetServices();

      }
    }
  }

  filterLines() {
    this.lineSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        distinctUntilChanged(),
        exhaustMap(value=> {
          if(!value){
            this.filteredLines.next([...this.lines])
            return of([...this.lines]);
          }
          const requestBody = {
            activeFlag:true,
            entityBusinessType:'LINE',
            name: value,
          };
          return this.service.get(Api.EXTERNAL_ENTITIES_FOR_DD, requestBody).pipe(
            map(res => res.contents || []),
            tap(filteredResult => {
              return this.filteredLines.next([...filteredResult]);
            })
          )

        })
      )
      .subscribe(() => {
        this.searching = false;
      },
      error => { this.searching = false; });
  }

  filterConsortium() {
    this.consortiumSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.consortiums) { return []; }
          if(!search) { this.filteredConsortium.next(this.consortiums); }
          return this.consortiums.filter(consortium => (consortium.name.toLowerCase().indexOf(search.toLowerCase()) > -1));
        }),
        delay(200)
      )
      .subscribe(filteredConsortium => {
        this.searching = false;
        this.filteredConsortium.next(filteredConsortium);
      },
      error => { this.searching = false; });
  }

  filterConsortiumDestination() {
    this.polSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.consortiumDestinations) { return []; }
          if(!search) { this.filteredConsortiumDest.next(this.consortiumDestinations); }
          return this.consortiumDestinations.filter(consortiumDest => (consortiumDest.destinationName.toLowerCase().indexOf(search.toLowerCase()) > -1)
          || (consortiumDest.destinationCode.toLowerCase().indexOf(search.toLowerCase()) > -1));
        }),
        delay(200)
      )
      .subscribe(filteredConsortiumDest => {
        this.searching = false;
        this.filteredConsortiumDest.next(filteredConsortiumDest);
      },
      error => { this.searching = false; });
  }

  filterDestinations() {
    this.destinationSearchCtrl.valueChanges.pipe(tap(() => this.searching = true),
      takeUntil(this.onDestroy),
      debounceTime(200),
      distinctUntilChanged(),
      exhaustMap(value => {
        if (!value) {
          this.filteredDestinations.next([...this.destinations]);
          return of([...this.destinations]);
        }
        const requestBody = {
          name: value,
        };
        return this.service.get(Api.DESTINATION_NAMES_FOR_DD, requestBody).pipe(
          map(res => res.contents || []),
          tap(filteredResults => {
            this.destinations = unionBy(this.destinations, filteredResults, 'id');
            this.filteredDestinations.next([...filteredResults]);
          })
        );
      })
    ).subscribe(() => this.searching = false);
  }

  //destination disable condition check for liner Services
  checkDestinationDeactivateCondition(d:any,isConsortiumDestination:boolean){
    if((d.deactivated || d.destinationId==this.destinationId.value || this.checkDestinationIdPresent(d.destinationId))
        && isConsortiumDestination){
       return true;
    }
    if(!isConsortiumDestination && this.checkDestinationIdPresent(d.id)){
      return true;
    }
    return false;
  }       
  
  //check Destination Id is Present in port id of liner Services
  private checkDestinationIdPresent(destinationId: number): boolean {
    const isPresent = _.findWhere(this.linerServices.value, { portId: destinationId }) ? true : false;
    return isPresent;
  }

  setDestinationsValueChangeEvent(value: number) {
    let selectedDestination: any;
    const transformedConsortiumDestinations = this.consortiumDestinations.map(d => ({
        id: d.destinationId,       
        name: d.destinationName,   
        code: d.destinationCode    
    }));

    this.logger.info("Transformed Consortium Destinations:", transformedConsortiumDestinations);
    this.logger.info("Destination List before merge:", this.destinations);

    this.destinations = unionBy(this.destinations, transformedConsortiumDestinations, 'id');
    this.logger.info("Destination List after merge:", this.destinations);

    this.filteredDestinations.pipe(take(1)).subscribe(destinationList => {
        selectedDestination = this.destinations.find(destination => destination.id === value) ||
            destinationList.find(destination => destination.id === value);
    });

    if (selectedDestination && !this.destinations.some(destination => destination.id === selectedDestination.id)) {
        this.destinations.push(selectedDestination);
    }
}

  private setDestinationValueChangeEvent(){
    this.destinationId.valueChanges.subscribe(value => {
      this.linerServices.clear(); 
      let serviceForm=this.ServiceForm();
      serviceForm.get('portId').setValue(this.polId.value);
      this.linerServices.push(serviceForm);
      this.linerServices.push(this.ServiceForm());
    });  
  }

  destinationChanged(item:any,index:number){
    let portId=item.get('portId').value;
    this.logger.info('index value',index);
    let destinationId=item.get('destinationId').value;
    if(portId && destinationId){
       if(index==0){
          let consortiumService=_.where(this.selectedConsortium.consortiumServiceDetails,{destinationId:destinationId,portId:portId});
          if(consortiumService.length>=1){
            this.linerServices.at(0).patchValue(consortiumService[0]);
            this.linerServices.at(0).get('sequenceNo').setValue(index+1);
            this.linerServices.at(index+1).get('portId').setValue(item.get('destinationId').value);
            this.linerServices.at(index+1).get('sequenceNo').setValue(2);
          } else {
            this.linerServices.at(0).get('transitTime').reset();
            this.linerServices.at(0).get('arrivalDayPol').reset();
            this.linerServices.at(0).get('mode').reset();
            let serviceForm=this.linerServices.at(0);
            this.linerServices.clear();
            this.linerServices.push(serviceForm);
            let form=this.ServiceForm();
            form.get('sequenceNo').setValue(2);
            this.linerServices.push(form);
          }
      }
      else if(index>0) {
        this.addServiceForm(destinationId,index);
      }
    }
  }

  private addServiceForm(destinationId:number,index:number){
    if(this.linerServices.at(index+1)?.value){
      let portId=this.linerServices.at(index+1).get('portId').value;
      if(portId){
        this.removeFieldFromLinerServices(index+1);
      }
    }
    if(destinationId!=this.destinationId?.value && index>0){
      let formToPush=this.ServiceForm();
      formToPush.get('portId').setValue(destinationId);
      formToPush.get('sequenceNo').setValue(index+2);
      this.linerServices.push(formToPush);
    }
  }

  removeFieldFromLinerServices(index:number){
    let totalLength=this.linerServices.length;
    for(let i=index;i<totalLength;i++){
       this.linerServices.removeAt(index);
    }
  }

  ServiceForm(data?:any){
    return this.formBuilder.group({
      sequenceNo:[data?data.sequenceNo:null],
      portId:[data?data.portId:null,[Validators.required]],
      destinationId:[data?data.destinationId:null,[Validators.required]],
      mode:[data?data.mode:null,[Validators.required]],
      transitTime:[data?data.transitTime:null,[Validators.required,Validators.pattern('^[1-9]+[0-9]*$')]],
      arrivalDayPol:[data?data.arrivalDayPol:null,[Validators.required]]
    })
  }

  addServiceField(){
    this.linerServices.push(this.ServiceForm());
  }

  removeServiceField(index:number){
    this.linerServices.removeAt(index);
  }

  onSave(){
    this.linerServiceForm.markAllAsTouched();
    if(this.linerServiceForm.valid)
    {
      this.isEditedData=true;
       if(this.id.value){
         this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT);
       }
       else {
        this.openDailog(Message.SAVE_OPEN_DAILOG);
       }  
    }
  }

  saveLinerServiceModule(){
    this.logger.info('Liner service Form Value before validation',this.linerServiceForm.getRawValue());
    this.linerServiceForm.markAllAsTouched();
    let method=(this.id.value)?'put':'post';
    let message=(this.id.value)?'updated':'saved';
    if(this.linerServiceForm.valid)
    {
      this.linerServiceForm.markAsUntouched();
      this.service[method](Api.LINER_SERVICE,this.linerServiceForm.getRawValue()).subscribe(res => {
        this.logger.info('linerService Saved Res',res);
        this.utilityService.notifier ('Linear Service Details '+message+' successfully', 'success');
        this.router.navigate([APP_ROUTES.LINER_SERVICE]);
      });
    }
  }

  onCancel(){
    if(this.linerServiceForm.dirty){
      this.isEditedData=false;
      this.id.value?this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT):
          this.openDailog(Message.CANCEL_OPEN_DAILOG);
    }else{
    this.router.navigate([APP_ROUTES.LINER_SERVICE]);
  }
}

private openDailog(message?:string){
  const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
      data:message,
      maxWidth:"300px",
      maxHeight:"150px"
    });

  dailogRef.afterClosed().subscribe(dailogResult => {
      if(dailogResult===false){
        return;
      }
      else {
        if(!this.isEditedData) {
          this.router.navigate([APP_ROUTES.LINER_SERVICE]);
        }
        else {
         this.saveLinerServiceModule();
        }
      }
  })
}


  openDeactivateForm(e:MatSlideToggleChange)
  {
    let data={id:this.id.value,route:APP_ROUTES.LINER_SERVICE,message:'Liner Service',api:Api.LINER_SERVICE_DEACTIVATE}
    const dailogRef=this.dailog.open(DeactivateComponent,{data:data});
    dailogRef.afterClosed().subscribe(value => {
      this.checked = !this.checked;
    })    
  }

  openReactivateForm(e:MatSlideToggleChange)
  {
    let data={id:this.id.value,route:APP_ROUTES.LINER_SERVICE,message:'Liner Service',api:Api.LINER_SERVICE_REACTIVATE}
    const dailogRef=this.dailog.open(ReactivateComponent,{data:data});
    dailogRef.afterClosed().subscribe(value => {
      this.checked = !this.checked;
    })    
  }

  getLinerServiceById(){
    if(this.id.value){
      this.service.get(Api.LINER_SERVICE+'/'+this.id.value).subscribe(res => {
        if(res){
          this.serviceResData=res;
          this.ensureEditDestinationsLoaded(res);
          this.linerServiceForm.patchValue(res);
          this.patchLinerServiceDetailsValue(res);
          this.showStatus=this.getStatus(res);
        }
      });
    }
  }

  private ensureEditDestinationsLoaded(res: any) {
    if (!this.destinations) this.destinations = [];
    const toAdd: any[] = [];
    const addIfMissing = (id: number, name: string) => {
      if (id && name && !this.destinations.some((d: any) => d.id === id)) {
        toAdd.push({ id, name, code: '' });
      }
    };
    addIfMissing(res.destinationId, res.destinationName);
    (res.linerServiceDetails || []).forEach((d: any) => {
      addIfMissing(d.portId, d.portName);
      addIfMissing(d.destinationId, d.destinationName);
    });
    if (toAdd.length > 0) {
      this.destinations = [...this.destinations, ...toAdd];
      this.filteredDestinations.next([...this.destinations]);
    }
  }

  private patchLinerServiceDetailsValue(res:any){
     this.linerServices.clear();
     res.linerServiceDetails.forEach(element => {
       this.linerServices.push(this.ServiceForm(element));
     });
  }

  private getStatus(data: any) {
    if (data.status == "APPROVED" && !data.submittedForApproval && this.deactivatePermission) {
      this.showDeactivateToggle=true;
      return null;
    }
    else if (data.status == "DEACTIVATED" && !data.submittedForApproval && this.reactivatePermission) {
      this.showReactivateToggle=true;
      return "Deactivated...";
    } else {
      return this.utilityService.getApprovalMessage({status:data.status,
        submittedForApproval: data.submittedForApproval,
        deactivationWefDate: data.deactivate?.deactivationWefDate,
        reactivationWefDate: data.reactivate?.reactivationWefDate});
    }
  }

  getPortOfLoadings(){
    this.service.get(Api.PORT_OF_LOADING).subscribe(res => {
      if(res){
        this.portOfLoadings=res; 
      }
    });
  }

  getModeList(){
    this.service.get(Api.MODE_LIST).subscribe(res => {
      if(res){
        this.modes=res; 
      }
    });
  }

  getLineList(){
    this.lineCriteria.activeFlag=true;
    this.lineCriteria.entityBusinessType='LINE';
    this.service.get(Api.EXTERNAL_ENTITIES_FOR_DD,this.lineCriteria).subscribe(res => {
       if(res){
         this.logger.info('Line res',res);
         this.lines=res.contents;
         this.filteredLines.next(this.lines);
       }
    });
  }

  getConsortiumList(){
    this.consortiumId.reset();
     this.service.get(Api.CONSORTIUM_FOR_DD,this.consortiumCriteria).subscribe(res => {
       if(res){
         this.consortiums=res;
         this.filteredConsortium.next(this.consortiums);
         if(this.consortiumId.value){
            this.selectedConsortium=_.findWhere(this.consortiums,{id:this.consortiumId.value});
            if(this.selectedConsortium){
              this.consortiumDestinations=this.selectedConsortium.destinationDetails;
              this.filteredConsortiumDest.next(this.consortiumDestinations);
            }
         }
       }
     })
  }

  getDestinationList(){
    this.service.get(Api.DESTINATION_NAMES_FOR_DD,this.destinationCriteria).subscribe(res => {
      if(res){
        this.logger.info("Destination", res);
        this.destinations = unionBy(res.contents, this.destinations || [], 'id');
        this.filteredDestinations.next([...this.destinations]);
      }
    });
  }

  checkTotalTransitTime(){
    let totalSum=this.linerServices.value.map(c => c.transitTime).reduce((sum, current) => sum + current);
    this.logger.info('total Sum Value',totalSum);
    if(totalSum > this.transitTime.value || !this.transitTime.value){
      this.utilityService.notifier('Liner Service Transit Time is more than the Total Transit Time','info');
    }
  }

  private checkAllPermissions(){
    let permissionCodes=[PermissionKey.LINER_SERVICE_MODULE_EDIT_PERMISSION,PermissionKey.LINER_SERVICE_MODULE_DEACTIVATE_PERMISSION,
         PermissionKey.LINER_SERVICE_MODULE_REACTIVATE_PERMISSION];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.LINER_SERVICE_MODULE);
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.LINER_SERVICE_MODULE_EDIT_PERMISSION})?.show?true:false;
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.LINER_SERVICE_MODULE_EDIT_PERMISSION})?.show?true:false;
    this.reactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.LINER_SERVICE_MODULE_REACTIVATE_PERMISSION})?.show?true:false;
    this.deactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.LINER_SERVICE_MODULE_DEACTIVATE_PERMISSION})?.show?true:false;
  }

  get viewLog(){return this.linerServiceForm.get('viewLog')?.value}
  get id(){ return this.linerServiceForm.get('id'); }
  get consortiumId(){ return this.linerServiceForm.get('consortiumId'); }
  get lineId(){ return this.linerServiceForm.get('lineId'); }
  get transitTime(){ return this.linerServiceForm.get('transitTime'); }
  get destinationId(){ return this.linerServiceForm.get('destinationId'); }
  get polId(){ return this.linerServiceForm.get('polId'); }
  get linerServices(){ return (<FormArray>this.linerServiceForm.get('linerServiceDetails')) }
}
